import { http } from './config';

let authData = {};

if (localStorage.getItem('vibbra-user') != null) {
  authData = JSON.parse(localStorage.getItem('vibbra-user'));
  http.defaults.headers.common['access-token'] = authData.access_token;
  http.defaults.headers.common.client = authData.client_code;
  http.defaults.headers.common.expiry = authData.expiry;
  http.defaults.headers.common['token-type'] = 'Bearer';
  http.defaults.headers.common.uid = authData.uid;
}

export default {
  sign_in: (email, password) =>
    http.post('vibbrante/auth/sign_in', { email, password }),
  sign_up: (email, password, password_confirmation, name, accepted_term) =>
    http.post('vibbrante/auth', {
      email,
      password,
      password_confirmation,
      name,
      accepted_term,
    }),
  sign_out: () =>
    http({
      method: 'delete',
      url: 'vibbrante/auth/sign_out',
    }),
  revoveryPass: email =>
    http({
      method: 'post',
      url: 'vibbrante/auth/password',
      data: {
        email,
        redirect_url: process.env.BASE_URL + 'vibbrant/new-pass',
      },
    }),
  updatePass: (password, password_confirmation, headers) =>
    http({
      method: 'PUT',
      url: 'vibbrante/auth/password',
      data: {
        password,
        password_confirmation,
      },
      headers,
    }),
  vibbranteAcceptTerm: () =>
    http({
      method: 'put',
      url: 'vibbrante/users/0',
      data: {
        vibbrante: {
          accepted_term: true,
        },
      },
    }),
  getVibbranteData: () =>
    http({
      method: 'get',
      url: 'vibbrante/users/0',
    }),
  addSkill: skill =>
    http({
      method: 'post',
      url: 'vibbrante/vibbrante_skills',
      data: {
        vibbrante_skill: {
          id: skill.id,
          description: skill.description,
          score: skill.score,
        },
      },
    }),
  deleteSkill: skill =>
    http({
      method: 'delete',
      url: 'vibbrante/vibbrante_skills/' + skill.id,
    }),
  updateProfile: vibbrante =>
    http({
      method: 'put',
      url: 'vibbrante/users/0',
      data: { vibbrante },
    }),
  uploadPortfolio: fileData =>
    http({
      method: 'put',
      url: 'vibbrante/users/0/update_portfolio',
      data: fileData,
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000,
    }),
  removePortfolio: () =>
    http({
      method: 'delete',
      url: 'vibbrante/users/0/remove_portfolio',
    }),
  loadPendingContracts: () =>
    http({
      method: 'get',
      url: 'vibbrante/contracts/pending',
    }),
  loadActivesContracts: () =>
    http({
      method: 'get',
      url: 'vibbrante/contracts/actives',
      timeout: 9999999,
    }),
  loadClosedContracts: (page = 1) =>
    http({
      method: 'get',
      url: 'vibbrante/contracts/closed?page=' + (page || 1),
    }),
  vibbranteGetContract: contract_id =>
    http({
      method: 'get',
      url: 'vibbrante/contracts/' + contract_id,
      timeout: 99999,
    }),
  vibbranteGetContractModels: contract_id =>
    http({
      method: 'get',
      url: 'vibbrante/contracts/' + contract_id + '/contract_models',
    }),
  vibbranteGetSignedContract: contract_id =>
    http({
      method: 'get',
      url: 'vibbrante/contracts/' + contract_id + '/signed_contract',
    }),
  vibbranteRejectContract: (contract_id, reject_text, cancellation_reason_id) =>
    http({
      method: 'put',
      url: 'vibbrante/contracts/' + contract_id,
      data: {
        contract: {
          id: contract_id,
          reject_description: reject_text,
          status: 'reject_by_vibbrante',
          cancellation_reason_id,
        },
      },
    }),
  vibbranteAcceptContract: contract =>
    http({
      method: 'put',
      url: 'vibbrante/contracts/' + contract.id,
      data: {
        contract: {
          id: contract.id,
          status: 'waiting_confirmation_from_client',
          hour_value_vibbrante: contract.hour_value_vibbrante,
          contract_hours: contract.expect_hours,
          expected_start_date: contract.expected_start_date,
          hour_available: contract.hour_available,
        },
      },
    }),
  vibbranteCloseByReject: contract_id =>
    http({
      method: 'put',
      url: 'vibbrante/contracts/' + contract_id,
      data: {
        contract: {
          id: contract_id,
          status: 'close_by_reject',
        },
      },
    }),
  vibbranteCreateTask: (contract_id, task) =>
    http({
      method: 'post',
      url: 'vibbrante/tasks',
      data: {
        task: {
          contract_id,
          description: task.description,
          duration: task.hours + ':' + task.minutes,
        },
      },
    }),
  vibbranteTaskComment: task_id =>
    http({
      method: 'get',
      url: 'vibbrante/tasks/' + task_id + '/comments',
    }),
  vibbranteCreateTaskComment: (task_id, description) =>
    http({
      method: 'post',
      url: 'vibbrante/tasks/' + task_id + '/comment',
      data: {
        task_comment: {
          description,
        },
      },
    }),
  vibbranteContractComment: contract_id =>
    http({
      method: 'get',
      url: 'vibbrante/contracts/' + contract_id + '/comments',
    }),
  vibbranteContractCommentToRead: contract_id =>
    http({
      method: 'put',
      url: 'vibbrante/contracts/' + contract_id + '/mark_comments_read',
    }),
  vibbranteCreateContractComment: (contract_id, description) =>
    http({
      method: 'post',
      url: 'vibbrante/contracts/' + contract_id + '/comment',
      data: {
        contract_comment: {
          description,
        },
      },
    }),
  vibbranteLoadSkills: () =>
    http({
      method: 'get',
      url: 'vibbrante/list/skills',
    }),
  vibbranteLoadTags: () =>
    http({
      method: 'get',
      url: 'vibbrante/list/tags',
    }),
  vibbranteNotifications: () =>
    http({
      method: 'get',
      url: 'vibbrante/notifications',
    }),
  vibbranteCreateHelpMessage: (subject_id, body) =>
    http({
      method: 'post',
      url: 'vibbrante/help_messages',
      data: {
        help_message: {
          help_subject_id: subject_id,
          body_message: body,
        },
      },
    }),
  vibbranteLoadSubjects: () =>
    http({
      method: 'get',
      url: 'vibbrante/list/subjects',
    }),
  vibbranteExtract: month =>
    http({
      method: 'get',
      url: 'vibbrante/wallet/extract?month=' + month,
    }),
  vibbranteBalances: () =>
    http({
      method: 'get',
      url: 'vibbrante/wallet/balances',
    }),
  vibbranteSetNotificationRead: notification_id =>
    http({
      method: 'put',
      url: 'vibbrante/notifications/' + notification_id,
      data: {
        notification: {
          read: true,
        },
      },
    }),
  vibbranteTransferMoney: transfer =>
    http({
      method: 'post',
      url: 'vibbrante/vibbrante_payments',
      data: transfer,
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  vibbranteRatingContract: contract =>
    http({
      method: 'put',
      url: 'vibbrante/contracts/' + contract.id + '/rating',
      data: {
        contract: {
          rating_client: contract.rating_client,
          rating_management: contract.rating_management,
          rating_availability: contract.rating_availability,
          rating_interest_new_job: contract.rating_interest_new_job,
          rating_client_comment: contract.rating_client_comment,
        },
      },
    }),
  vibbranteGetClientContract: client_id =>
    http({
      method: 'get',
      url: 'vibbrante/contracts/' + client_id + '/client',
    }),
  vibbranteLoadCancellationReasons: () =>
    http({
      method: 'get',
      url: 'vibbrante/cancellation_reasons',
    }),
  vibbranteGetCurrentCompany: () =>
    http({
      method: 'get',
      url: 'vibbrante/current_company',
    }),
};



// WEBPACK FOOTER //
// ./src/api/vibbrante.js